import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { PaaElaborarComponent } from 'src/app/pages/paa-elaborar/paa-elaborar.component';

@Injectable()
export class PaaGuard implements CanDeactivate<PaaElaborarComponent> {
  canDeactivate(component: PaaElaborarComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}
